import { Badge } from "../../../../components/ui/common/badge";
import { TableCell, TableRow } from "../../../../components/ui/common/table";
import { FACILITY_TYPES } from "../../../../config/constants";
import {
  getCountryName,
  getFacilityOwnershipLabel,
  getFacilityTypeLabel
} from "../../facilityDrawer/utils/facilitySourceRows.utils";
import { FACILITY_TABLE_COLUMN_CLASS } from "../constants/facilityList.constants";
import { FacilityTableRowProps } from "../types/facilityList.types";
import { FacilityRowActions } from "./FacilityRowActions";

/** One facility row: name + city·country, type, ownership badge, actions. */
export const FacilityTableRow = ({
  row,
  countriesData,
  onView,
  onEdit,
  onDelete
}: FacilityTableRowProps) => {
  const formattedFacilityType = FACILITY_TYPES.find(type => type.value === row?.facilityType) || {
    text: row?.facilityType,
    value: row?.facilityType
  };
  const countryName = getCountryName(countriesData, row?.facilityCountry);
  const subtext = [row?.facilityCity, countryName].filter(Boolean).join(" · ");

  return (
    <TableRow className="tw-bg-white hover:tw-bg-muted/50">
      <TableCell className={FACILITY_TABLE_COLUMN_CLASS.name}>
        <div className="tw-text-sm tw-font-medium tw-text-foreground">{row?.facilityName}</div>
        <div className="tw-mt-0.5 tw-font-mono tw-text-[11px] tw-text-muted-foreground">
          {subtext}
        </div>
      </TableCell>
      <TableCell className={`${FACILITY_TABLE_COLUMN_CLASS.type} tw-text-sm tw-text-foreground`}>
        {getFacilityTypeLabel(formattedFacilityType.value)}
      </TableCell>
      <TableCell className={FACILITY_TABLE_COLUMN_CLASS.ownership}>
        <Badge
          variant="outline"
          className="tw-rounded-full tw-text-xs tw-font-normal tw-text-foreground"
        >
          {getFacilityOwnershipLabel(row?.facilityOwnership)}
        </Badge>
      </TableCell>
      <TableCell className={FACILITY_TABLE_COLUMN_CLASS.actions}>
        <FacilityRowActions
          onView={() => onView({ ...row, facilityType: formattedFacilityType.value })}
          onEdit={() => onEdit(row)}
          onDelete={() => onDelete({ _id: row?._id })}
        />
      </TableCell>
    </TableRow>
  );
};
